export const SUN = 'eventbrite';
export const FACEBOOK = 'facebook';
export const INSTAGRAM = 'instagram';
export const SPOTIFY = 'spotify';
export const SONGKICK = 'songkick';
export const BANDSINTOWN = 'bandsintown';
export const SEATGEEK = 'seatgeek';
export const EVENTFUL = 'eventful';
export const INNER = 'inner';
export const OUTER = 'outer';
export const CENTER = 'center';
